<style scoped>
.role-checkbox {
  padding-right: 8px;
}
td {
  padding: 4px;
  text-align: center;
}
table {
  width: 100%;
}
</style>

<template>
<mu-container>
  <mu-card>
    <mu-card-text>
      <table border="1">
        <tr>
          <th>{{$t('api.name')}}</th>
          <th>{{$t('api.method')}}</th>
          <th>{{$t('api.enrollment')}}</th>
          <th>{{$t('api.management')}}</th>
          <th>{{$t('api.roles')}}</th>
        </tr>
        <tr v-for="(api, index) in apis" :key="index">
          <td><a href="#" @click="onClickApi(api.apiName)">{{api.apiName}}</a></td>
          <td>{{capitalize(api.type)}}</td>
          <td>
            <mu-checkbox v-model="apis[index].enrollment" @change="onActionEdit(index)"></mu-checkbox>
          </td>
          <td>
            <mu-checkbox v-model="apis[index].management" @change="onActionEdit(index)"></mu-checkbox>
          </td>
          <td>
            <mu-checkbox 
            v-for="role in roles" 
            v-model="apis[index].roles" 
            :label="firstLetterCapitalized(role)" 
            class="role-checkbox" 
            :value="role" 
            @change="onActionEdit(index)"
            />
          </td>
        </tr>
      </table>
    </mu-card-text>
  </mu-card>
</mu-container>
</template>

<script>
// Library
import axios from "axios";

export default {
  name: 'ApiPage',
  components: {
    
  },
  data() {
    return {
      // Object
      apis: [],
      flagFetchedApis: false,
      
      roles: ["student", "assistant", "teacher", "admin"],
    }
  },
  computed: {
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  watch: {
  },
  created() {
    if(this.isAdmin) {
      this.fetchApis();
    } else {
      this.$router.push({
        name: 'Home'
      });
    }
  },
  methods: {
    // Fetch
    fetchApis() {
      axios.get(this.$store.getters.urlApi + "api", {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.apis = response.data.data.apis
        if(this.apis.length) {
          this.apis = this.apis.map(api => {
          var data = api;
          if(Array.isArray(api.roles) && api.roles.length === 0) {
            data.roles = this.roles;
          }
          return data;
          });
        }
        this.flagFetchedApis = true;
      });
    },
    
    onActionEdit(index) {
      axios.put(this.$store.getters.urlApi + "api/" + this.apis[index]._id, {
        roles: this.apis[index].roles,
        enrollment: this.apis[index].enrollment,
        management: this.apis[index].management
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    
    onClickApi(apiName) {
      this.$router.push({
        name: 'Pass',
        query: {
          apiName: apiName
        }
      });
    },
    
    firstLetterCapitalized(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    capitalize(str) {
      return str.toUpperCase();
    },
  }
}
</script>
